import React from 'react';
import { Page } from '../Page';
export function DividerFundamentals() {
  return <Page hideFooter variant="dark" data-id="element-636" data-mp="3dc51sc7u6hwv">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-637" data-mp="3db3qc6mwrtem">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-638" data-mp="3r3jp2v8s159q">
          Part Two
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-639" data-mp="3m4qhtkk32ai0">
          The Fundamentals
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-640" data-mp="2ygp3tw44y1v7" />
      </div>
    </Page>;
}